const colors = {
  blackRock: '#282C37',
  nepal: '#9BAEC0',
  solitude: '#D9E1E8',
  summerSky: '#2B90D9',
  white: '#ffffff'
}

export default colors;


// WEBPACK FOOTER //
// ./src/utils/colors.js